import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Button } from '@/components/ui/button';
import { ArrowRight, Music } from 'lucide-react';

export function FeaturedArtist() {
  const { data: artist } = useQuery({
    queryKey: ['featured-artist'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('organizations')
        .select('id, name, slug, genre, bio, logo_url')
        .eq('featured', true)
        .not('slug', 'is', null)
        .limit(1)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
  });

  if (!artist) return null;

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div className="aspect-square rounded overflow-hidden bg-card relative">
            {artist.logo_url ? (
              <>
                <img src={artist.logo_url} alt={artist.name} className="h-full w-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-card/60 to-transparent" />
              </>
            ) : (
              <div className="h-full w-full flex items-center justify-center">
                <Music className="h-24 w-24 text-muted-foreground/30" />
              </div>
            )}
          </div>
          <div className="space-y-4">
            <p className="text-sm font-medium text-accent uppercase tracking-wider">Featured Artist</p>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground">{artist.name}</h2>
            {artist.genre && (
              <p className="text-muted-foreground">{artist.genre}</p>
            )}
            {artist.bio && (
              <p className="text-muted-foreground leading-relaxed line-clamp-4">{artist.bio}</p>
            )}
            <Button asChild className="bg-accent text-accent-foreground hover:bg-accent/90">
              <Link to={`/artists/${artist.slug}`}>
                View Artist <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
